import {CallFunction} from "../../public/bundles/w3comhulk/callFunction";

export const createDecompte = (rows) => {
    var callFunction = new CallFunction('createDecompte', 'fad fa-layer-plus fa-2x');
    callFunction.showModal('Créer un décompte vendeur.');
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    callFunction.addValidateBtn(function () {

        var data = rows.toArray();
        callFunction.startLoading();
        $.ajax({
            data: {data},
            type: 'POST',
            url: urls.createBr,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                var vh = rep.VH.split(';');
                vh.forEach(function (el, index) {
                    callFunction.addLineResult('Décompte créé : ' + el, 'success')
                });
            },
            error: function () {
                callFunction.addUnknowError();
            },
            complete: function () {
                callFunction.stopLoading();
                callFunction.addReloadButton();
            }
        });
    });
};

export const createDecompteDraft = (rows) => {
    var callFunction = new CallFunction('createDecompteDraft', 'fad fa-layer-plus fa-2x');
    callFunction.showModal('Créer un décompte pré enregistré.');
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    callFunction.addValidateBtn(function () {

        var data = rows.toArray();
        callFunction.startLoading();
        $.ajax({
            data: {data},
            type: 'POST',
            url: urls.createDecompteDraft,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                var vh = rep.VH.split(';');
                vh.forEach(function (el, index) {
                    callFunction.addLineResult('Décompte pré enregsitré créé : ' + el, 'success')
                });
            },
            error: function () {
                callFunction.addUnknowError();
            },
            complete: function () {
                callFunction.stopLoading();
                callFunction.addReloadButton();
            }
        });
    });
};

export const sendDecompteOnEmail = (rows) => {
    var callFunction = new CallFunction('sendDecompteOnEmail','fad fa-paper-plane fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Envoyer les documents par email.')
    if(!callFunction.checkRowsLength(rows,1,callFunction)){
        return;
    }
    var objWithoutErrors = [];
    rows.map(function (el,index) {
       // if(el.U_W3C_EMAI === ''){
         //   callFunction.addLineResult('Decompte n°' + el.NumDecompte + ' : L\'email du contact n\'est pas renseigné.', 'danger')
       // } else if (el.PDFFileName === '' ){
            //callFunction.addLineResult('Decompte n°' + el.NumDecompte + ' : Le decompte n\'est pas créée.', 'danger')
        //} else {
            objWithoutErrors.push(el);
            callFunction.addLineResult('Decompte n°' + el.NumDecompte + ' : ' + el.U_W3C_EMAI, 'success')
        //}
    });

    var param = {
      'sendMailList' : objWithoutErrors
    };

    if(objWithoutErrors.length !== 0){
        callFunction.addValidateBtn(function(){
            callFunction.startLoading();
            $.post(urls.sendDecompte, param, function(rep) {
                window.location.reload();
            }).fail(function(){
                window.location.reload();
            })
        });
    }
};


// WEBPACK FOOTER //
// ./assets/js/display_decompte.js